import moment from 'moment';

export default function formatDateTime(date) {
  return moment.unix(date).format('D MMM, YYYY, h:mm A');
}
